import { Box, SxProps, Theme, Typography } from '@mui/material';
import { UseTableCellProps } from 'react-table';
import { CustomerContractInventoryGridItem } from 'shared/types/customerManagement';
import { formatDate } from 'shared/utility';

const gridStyles: SxProps<Theme> = {
  display: 'grid',
};

export function DateColumn(props: UseTableCellProps<CustomerContractInventoryGridItem>) {
  const { value } = props;
  let dateToDisplay = '';

  try {
    dateToDisplay = value ? formatDate(new Date(value)) : value;
  } catch (error) {
    console.log('invalid date format: ', value);
  }

  return (
    <Box sx={gridStyles}>
      <Typography variant='body2'>{dateToDisplay}</Typography>
    </Box>
  );
}
